

// import React, { useState } from "react";
// import { Carousel } from "react-bootstrap";

// const carImages = [
//   {
//     src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2FCAROUSEL%2Fnew%20hector%2Fmgi-hector-thm-img-0003.webp?alt=media&token=2cf5926f-599a-4bd0-b7ae-c68cc1c855ad",
//     color: "#F64752",
//   },
//   {
//     src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fmgi-hector-thm-img-0004.webp?alt=media",
//     color: "#ffffff",
//   },
//   {
//     src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fmgi-hector-thm-img-0005.webp?alt=media",
//     color: "#121010",
//   },
//   {
//     src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fmgi-hector-thm-img-0001.webp?alt=media",
//     color: "rgba(11, 11, 34, 1)",
//   },
//   {
//     src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2Fmgi-hector-thm-img-0002.webp?alt=media",
//     color: "#A1A4AD",
//   },
// ];

// const Hectorcarrousel = ({ onColorChange }) => {
//   const [activeIndex, setActiveIndex] = useState(0);

//   const handleSelect = (index) => {
//     setActiveIndex(index);
//     onColorChange(carImages[index].color); 
//   };

//   return (
//     <div style={{ position: "relative",margin:0,padding:0 ,height:"90vh" }}>
//       <Carousel
//         activeIndex={activeIndex}
//         onSelect={handleSelect}
//         interval={null}
//         controls={false}
//         indicators={false}
//       >
//         {carImages.map((car, index) => (
//           <Carousel.Item key={index}>
//             <img
//               src={car.src}
//               className="d-block w-100"
//               alt="hector"
//               style={{
//                 width: "100%",
//                 height: "390px",
//                 objectFit: "cover",
//               }}
//             />
//           </Carousel.Item>
//         ))}
//       </Carousel>

//       {/* Color Dots */}
//       <div
//         style={{
//           position: "absolute",
//           // bottom: "20px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           display: "flex",
//           gap: "12px",
//         }}
//       >
//         {carImages.map((car, index) => (
//           <div
//             key={index}
//             onClick={() => handleSelect(index)}
//             style={{
//               width: 29,
//               height: 29,
//               borderRadius: "50%",
//               backgroundColor: car.color,
//               cursor: "pointer",
//               border:
//                 activeIndex === index ? "2px solid #000" : "1px solid #ccc",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Hectorcarrousel;




import React, { useState } from "react";
import { Carousel } from "react-bootstrap";

const carImages = [
  {
    src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0003.webp?alt=media&token=4ec1ca6e-a441-4e25-b0a6-afea9a0ffa85",
    color: "#F64752",
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    color: "#ffffff",
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0005.webp?alt=media&token=e3a51e6c-6fac-46cb-b2ca-9742864eb7c0",
    color: "#121010",
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0001.webp?alt=media&token=0de8d679-e877-4235-aec8-9d3343a62a30",
    color: "rgba(11, 11, 34, 1)",
  },
  {
    src: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0002.webp?alt=media&token=4dea8393-fece-4e42-a138-d76e1df23651",
    color: "#A1A4AD",
  },
];

const Hectorcarrousel = ({ onColorChange }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSelect = (index) => {
    setActiveIndex(index);
    if (onColorChange) {
      onColorChange(carImages[index].color);
    }
  };

  return (
    <>
      <div className="hector-carousel">
        <Carousel
          activeIndex={activeIndex}
          onSelect={handleSelect}
          interval={null}
          controls={false}
          indicators={false}
        >
          {carImages.map((car, index) => (
            <Carousel.Item key={index}>
              <img src={car.src} className="car-image" alt="hector" />
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Color Dots */}
        <div className="color-dots">
          {carImages.map((car, index) => (
            <div
              key={index}
              onClick={() => handleSelect(index)}
              style={{ backgroundColor: car.color }}
              className={`dot ${activeIndex === index ? "active" : ""}`}
            />
          ))}
        </div>
      </div>

      {/* CSS in same file */}
      <style>{`
        .hector-carousel{
          position: relative;
          width: 100%;
        }

        .car-image{
          width: 100%;
          height: 60vh;
          object-fit: cover;
        }

        /* Tablet */
        @media (max-width: 992px){
          .car-image{
            height: 70vh;
          }
        }

        /* Mobile */
        @media (max-width: 576px){
          .car-image{
            height: 30vh;
          }
        }

        .color-dots{
          position: absolute;
          bottom: 15px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 12px;
        }

        .dot{
          width: 22px;
          height: 22px;
          border-radius: 50%;
          cursor: pointer;
          border: 1px solid #ccc;
        }

        .dot.active{
          border: 2px solid black;
        }
      `}</style>
    </>
  );
};

export default Hectorcarrousel;